var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/remote_timeline/components/button-pin.tsx";
const _excluded = ["instance"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { IconPin, IconPinnedOff, IconPinned } from '@tabler/icons';
import React, { useCallback, useMemo, useState } from 'react';
import { getPinnedHosts, pinHost, unpinHost } from 'soapbox/actions/remote_timeline';
import { useAppDispatch, useAppSelector } from 'soapbox/hooks';
import { makeGetRemoteInstance } from 'soapbox/selectors';
export const ButtonPin = _ref => {
  let {
      instance
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [hover, setHover] = useState(false);
  const pinnedHosts = useAppSelector(s => getPinnedHosts(s));
  const dispatch = useAppDispatch();
  const pinned = pinnedHosts.find(hs => hs.get('host') === instance);
  const getRemoteInstance = makeGetRemoteInstance();
  const favicon = useAppSelector(s => getRemoteInstance(s, instance)).get('favicon');
  const onClick = useCallback(() => {
    if (pinned) {
      dispatch(unpinHost(instance));
    } else {
      dispatch(pinHost(instance, favicon));
    }
  }, [dispatch, pinned, instance, favicon]);
  const finalProps = useMemo(() => _objectSpread(_objectSpread({}, props), {}, {
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    onClick
  }), [props, onClick]);
  if (hover) {
    return pinned ? /*#__PURE__*/React.createElement(IconPinnedOff, _extends({
      className: "cursor-pointer"
    }, finalProps, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 21
      }
    })) : /*#__PURE__*/React.createElement(IconPinned, _extends({
      className: "cursor-pointer"
    }, finalProps, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 84
      }
    }));
  }
  return pinned ? /*#__PURE__*/React.createElement(IconPinned, _extends({}, finalProps, {
    className: "text-accent-300",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 19
    }
  })) : /*#__PURE__*/React.createElement(IconPin, _extends({}, finalProps, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 80
    }
  }));
};